/* RunNetworkDiscoveryAction.js */

"use strict";

class RunAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        activeView,
        userSession,
        NetworkDiscoveryPlan
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        this._activeOrgId = userSession.activeOrganization.id;
        this._NetworkDiscoveryPlan = NetworkDiscoveryPlan;
        this._selectedPlanIds = [];
        this._selectedPlanNames = [];

        if (this._activeView && this._activeView.pagingFeed) {
            this._selectedPlanIds = this._activeView.getSelectedPlanIds().selectedRows || [];
        }

        this.run = this.run.bind(this);
    }

    run() {
        if (this._selectedPlanIds.length === 1) {
            this._activeView.pagingFeed
                .waitForRangeIdsUpdated()
                .then(() => {
                    if (this._selectedPlanIds.length === 1) {
                        return this._activeView.pagingFeed.getNetworkDiscoveryEntityById(
                            this._selectedPlanIds[0]
                        );
                    }
                    return Promise.resolve();
                })
                .then((selectedPlan) => {
                    if (selectedPlan) {
                        return selectedPlan.runNetworkDiscoveryWork({autoAddDevices: false}, {});
                    }
                    return Promise.resolve();
                })
                .then((results) => {
                    if (results.errorMsg) {
                        return this._modalUserFeedback.displayError({
                            error: {errorMsg: results.errorMsg},
                        });
                    }
                    return Promise.resolve();
                })
                .catch((err) => {
                    this._logger.warn({error: err}, "DeleteAction.run() - Error");
                    return this._modalUserFeedback.displayError({error: {errorMsg: err}});
                });
        } else {
            return Promise.resolve();
        }
    }
}

module.exports = RunAction;

RunAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "gameEditor.activeView",
    "$teve.userSession",
    "$teve.entities.NetworkDiscoveryPlan",
];

RunAction.$displayDetails = {
    type: "Action",
    name: "RunNetworkDiscovery",
    icon: "networkdiscovery.run_network_discovery",
    shown: true,
    title: "Run Discovery Plan",
    order: 1,
};
